import { Button as ButtonMUI } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  max-width: ${({ maxWidth }) => maxWidth};
`;

export const WrapperShown = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
`;

export const WrapperHidden = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ButtonShow = styled(ButtonMUI)`
  variant: text;
  font-size: 14px;
  box-shadow: none;
  font-weight: 700;
  padding-left: 0px;
  color: ${theme.palette.primary.main};
  text-transform: none;
  text-align: left;
  &:hover {
    color: ${theme.palette.primary.focus};
  }
`;

export const ButtonRemove = styled(ButtonMUI)`
  variant: text;
  padding-top: 0px;
  padding-right: 0px;
  font-size: 14px;
  box-shadow: none;
  font-weight: 400;
  text-transform: none;
`;
